<div class="flex h-full min-h-0 w-full flex-col overflow-hidden">
  <div class="shrink-0 space-y-2 border-b border-zinc-200 p-4 dark:border-zinc-800">
    <h4 class="m-0 text-sm font-semibold text-primary">Account mode</h4>
    <p class="m-0 text-xs text-secondary">
      Creator, brand, and agency visits for the selected period. Snapshots run overnight, so the latest day is yesterday.
      @if (rangeLabel) {
        {{ rangeLabel }}.
      }
    </p>
  </div>

  <admin-stats-period-filter [maxEndDate]="latestSnapshotDate" (periodChange)="onPeriodChange($event)" />

  @if (loadingState === 'error' && error) {
    <div
      class="mx-4 mt-4 shrink-0 rounded-lg border border-red-200 bg-red-50 p-3 dark:border-red-900/50 dark:bg-red-950/40"
    >
      <p class="m-0 text-sm text-red-700 dark:text-red-300">{{ error }}</p>
    </div>
  }

  <div class="flex min-h-0 flex-1 flex-col overflow-hidden bg-white dark:bg-zinc-950">
    @if (loadingState === 'loading') {
      <div class="p-4">
        <atom-loading-inline title="Loading account mode" message="Fetching report…" />
      </div>
    } @else {
      <div class="min-h-0 flex-1 overflow-auto scrollbar-transparent">
        <table class="min-w-full divide-y divide-gray-200 text-sm dark:divide-zinc-700">
          <caption class="sr-only">Account mode visits and events</caption>
          <thead class="sticky top-0 z-10 bg-gray-50 dark:bg-zinc-800/80">
            <tr>
              <th scope="col" class="px-4 py-3 text-left font-semibold text-gray-700 dark:text-zinc-300">
                <button
                  type="button"
                  [class]="getSortButtonClass('accountMode')"
                  (click)="toggleSort('accountMode')"
                  [disabled]="isLoading"
                  aria-label="Sort by account mode"
                >
                  <span>Account mode</span>
                </button>
              </th>
              <th scope="col" class="px-4 py-3 text-left font-semibold text-gray-700 dark:text-zinc-300">
                <button
                  type="button"
                  [class]="getSortButtonClass('activeUsers')"
                  (click)="toggleSort('activeUsers')"
                  [disabled]="isLoading"
                  aria-label="Sort by visits"
                >
                  <span>Visits</span>
                </button>
              </th>
              <th scope="col" class="px-4 py-3 text-left font-semibold text-gray-700 dark:text-zinc-300">
                <button
                  type="button"
                  [class]="getSortButtonClass('eventCount')"
                  (click)="toggleSort('eventCount')"
                  [disabled]="isLoading"
                  aria-label="Sort by events"
                >
                  <span>Events</span>
                </button>
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 dark:divide-zinc-800">
            @if (rows.length === 0) {
              <tr>
                <td colspan="3" class="px-4 py-10 text-center text-sm text-zinc-500">
                  No account mode rows for this period.
                </td>
              </tr>
            } @else {
              @for (row of rows; track row.accountMode) {
                <tr>
                  <th scope="row" class="px-4 py-3 font-medium text-zinc-900 dark:text-zinc-100">
                    {{ accountModeLabel(row.accountMode) }}
                  </th>
                  <td class="px-4 py-3 tabular-nums text-zinc-700 dark:text-zinc-300">
                    {{ row.activeUsers.toLocaleString() }}
                  </td>
                  <td class="px-4 py-3 tabular-nums text-zinc-700 dark:text-zinc-300">
                    {{ row.eventCount.toLocaleString() }}
                  </td>
                </tr>
              }
            }
          </tbody>
          @if (report) {
            <tfoot class="border-t border-gray-200 bg-gray-50 dark:border-zinc-800 dark:bg-zinc-900/60">
              <tr>
                <th scope="row" class="px-4 py-3 font-semibold text-zinc-900 dark:text-zinc-100">Total</th>
                <td class="px-4 py-3 font-semibold tabular-nums text-zinc-900 dark:text-zinc-100">
                  {{ report.totals.activeUsers.toLocaleString() }}
                </td>
                <td class="px-4 py-3 font-semibold tabular-nums text-zinc-900 dark:text-zinc-100">
                  {{ report.totals.eventCount.toLocaleString() }}
                </td>
              </tr>
            </tfoot>
          }
        </table>
      </div>
    }
  </div>
</div>
